import {
  PublicTransmedRegistration,
  TransmedRegistrationLcInput,
  TransmedRegistrationStage,
  TransmedRegistrationSubmitInput,
} from "../../../../dtos/transmed/process/registration/registration";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "../../..";
import TransmedRegistrationCreateApi from "../../../../api/transmed/registration/create";
import TransmedValidateRegistrationApi from "../../../../api/transmed/validation/registration";
import { TransmedRegistrationValidateInput } from "../../../../dtos/transmed/process/validation/registration";

class TransmedRegistrationServiceReader extends ServiceReader {
  public async outgoings(): Promise<PublicTransmedRegistration[]> {
    return await new TransmedValidateRegistrationApi().get();
  }
}

class TransmedRegistrationServiceCreator extends ServiceCreator {
  public async lcSave(lcId: string, withAccomodation: boolean): Promise<void> {
    return await new TransmedRegistrationCreateApi().post(
      new TransmedRegistrationLcInput(lcId, withAccomodation)
    );
  }
}

class TransmedRegistrationServiceUpdater extends ServiceUpdater {
  public async submit(id: number, coordinator: boolean = false): Promise<void> {
    return await new TransmedRegistrationCreateApi().put(
      `${id}`,
      new TransmedRegistrationSubmitInput(coordinator)
    );
  }

  public async validate(id: number): Promise<void> {
    return await new TransmedValidateRegistrationApi().put(
      `${id}`,
      new TransmedRegistrationValidateInput(
        TransmedRegistrationStage.valid,
        null
      )
    );
  }

  public async return(id: number): Promise<void> {
    return await new TransmedValidateRegistrationApi().put(
      `${id}`,
      new TransmedRegistrationValidateInput(
        TransmedRegistrationStage.returned,
        null
      )
    );
  }

  public async edit(id: number): Promise<void> {
    return await new TransmedValidateRegistrationApi().put(
      `${id}`,
      new TransmedRegistrationValidateInput(
        TransmedRegistrationStage.submitted,
        null
      )
    );
  }

  public async reject(id: number, message: string): Promise<void> {
    return await new TransmedValidateRegistrationApi().put(
      `${id}`,
      new TransmedRegistrationValidateInput(
        TransmedRegistrationStage.rejected,
        message
      )
    );
  }
}

class TransmedRegistrationServiceDeleter extends ServiceDeleter {}

export default class TransmedRegistrationService extends Service {
  public get read(): TransmedRegistrationServiceReader {
    return new TransmedRegistrationServiceReader();
  }
  public get create(): TransmedRegistrationServiceCreator {
    return new TransmedRegistrationServiceCreator();
  }
  public get update(): TransmedRegistrationServiceUpdater {
    return new TransmedRegistrationServiceUpdater();
  }
  public get delete(): TransmedRegistrationServiceDeleter {
    return new TransmedRegistrationServiceDeleter();
  }
}
